/**
 * ExecutionStatusOverlay - Shared component for node execution status indication.
 * Renders a status badge in the top-right corner and provides border/animation CSS classes.
 */
import React from 'react';
import { CheckCircle2, XCircle, Loader2, SkipForward } from 'lucide-react';
import type { ExecutionStatus } from './executionStatus';

interface ExecutionStatusOverlayProps {
  status?: ExecutionStatus;
}

export default function ExecutionStatusOverlay({ status }: ExecutionStatusOverlayProps) {
  if (!status || status === 'idle') return null;

  return (
    <div className="absolute -top-2 -right-2 z-10">
      {status === 'running' && (
        <div className="bg-white rounded-full p-0.5 shadow-md">
          <Loader2 className="w-4 h-4 text-blue-500 animate-spin" />
        </div>
      )}
      {status === 'success' && (
        <div className="bg-white rounded-full p-0.5 shadow-md">
          <CheckCircle2 className="w-4 h-4 text-green-500" />
        </div>
      )}
      {status === 'error' && (
        <div className="bg-white rounded-full p-0.5 shadow-md">
          <XCircle className="w-4 h-4 text-red-500" />
        </div>
      )}
      {status === 'skipped' && (
        <div className="bg-white rounded-full p-0.5 shadow-md">
          <SkipForward className="w-4 h-4 text-gray-400" />
        </div>
      )}
    </div>
  );
}
